/* Ambrelin – améliorations du modèle d'article (sommaire, FAQ, tableaux, produits cités) */
(function () {
  var contenu = document.querySelector('[data-amb-contenu]');
  if (!contenu) return;

  function slug(t) {
    return t.toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '').slice(0, 60);
  }

  /* 1. Tableaux défilants sur mobile */
  contenu.querySelectorAll('table').forEach(function (t) {
    if (t.parentElement.classList.contains('amb-art-table')) return;
    var w = document.createElement('div');
    w.className = 'amb-art-table';
    t.parentNode.insertBefore(w, t);
    w.appendChild(t);
  });

  /* 2. FAQ : le H2 « Questions fréquentes » et ses H3 deviennent un accordéon + données structurées */
  var h2s = Array.prototype.slice.call(contenu.querySelectorAll('h2'));
  var faqTitre = h2s.filter(function (h) { return /questions fr[ée]quentes|faq/i.test(h.textContent); })[0];
  if (faqTitre) {
    var bloc = document.createElement('section');
    bloc.className = 'amb-art-faq';
    faqTitre.parentNode.insertBefore(bloc, faqTitre);
    var n = faqTitre, items = [], courant = null, suivants = [];
    while (n) { suivants.push(n); n = n.nextElementSibling; if (n && n.tagName === 'H2') break; }
    suivants.forEach(function (el) {
      if (el === faqTitre) { bloc.appendChild(el); return; }
      if (el.tagName === 'H3') {
        var d = document.createElement('details');
        var s = document.createElement('summary');
        s.textContent = el.textContent;
        var r = document.createElement('div');
        r.className = 'amb-art-faq-rep';
        d.appendChild(s); d.appendChild(r);
        bloc.appendChild(d);
        courant = { q: el.textContent.trim(), r: r };
        items.push(courant);
        el.remove();
      } else if (courant) {
        courant.r.appendChild(el);
      } else {
        bloc.appendChild(el);
      }
    });
    if (items.length) {
      var ld = { '@context': 'https://schema.org', '@type': 'FAQPage', mainEntity: items.map(function (it) {
        return { '@type': 'Question', name: it.q, acceptedAnswer: { '@type': 'Answer', text: it.r.textContent.trim() } };
      }) };
      var sc = document.createElement('script');
      sc.type = 'application/ld+json';
      sc.textContent = JSON.stringify(ld);
      document.head.appendChild(sc);
    }
  }

  /* 3. Sommaire */
  var liste = document.querySelector('[data-amb-toc]');
  var titres = Array.prototype.slice.call(contenu.querySelectorAll('h2'));
  var aside = liste && liste.closest('.amb-art-toc');
  if (liste && titres.length >= 2) {
    var vus = {};
    titres.forEach(function (h) {
      if (!h.id) { var id = slug(h.textContent) || 'partie'; while (vus[id]) id += '-2'; vus[id] = 1; h.id = id; }
      var li = document.createElement('li');
      var a = document.createElement('a');
      a.href = '#' + h.id;
      a.textContent = h.textContent.replace(/\s+/g, ' ').trim();
      li.appendChild(a);
      liste.appendChild(li);
    });
    if (titres.length > 3) {
      var plus = document.createElement('button');
      plus.type = 'button';
      plus.className = 'amb-art-toc-plus';
      plus.textContent = 'Voir tout le sommaire';
      plus.addEventListener('click', function () { aside.classList.add('est-ouvert'); plus.remove(); });
      liste.after(plus);
    }
    if ('IntersectionObserver' in window) {
      var liens = liste.querySelectorAll('a');
      var obs = new IntersectionObserver(function (entrees) {
        entrees.forEach(function (e) {
          if (!e.isIntersecting) return;
          liens.forEach(function (l) { l.classList.toggle('est-actif', l.getAttribute('href') === '#' + e.target.id); });
        });
      }, { rootMargin: '-20% 0px -70% 0px' });
      titres.forEach(function (h) { obs.observe(h); });
    }
  } else if (aside) {
    aside.hidden = true;
  }

  /* 4. Barre de progression de lecture */
  var barre = document.querySelector('.amb-progress span');
  if (barre) {
    var maj = function () {
      var r = contenu.getBoundingClientRect();
      var total = r.height - window.innerHeight * 0.6;
      var p = Math.min(1, Math.max(0, -r.top / (total > 0 ? total : 1)));
      barre.style.transform = 'scaleX(' + p + ')';
    };
    window.addEventListener('scroll', maj, { passive: true });
    maj();
  }

  /* 5. Luminaires cités : cartes construites à partir des liens /products/ du texte */
  var zone = document.querySelector('[data-amb-produits]');
  var grille = document.querySelector('[data-amb-produits-grille]');
  if (zone && grille && window.fetch) {
    var handles = [];
    contenu.querySelectorAll('a[href*="/products/"]').forEach(function (a) {
      var m = a.getAttribute('href').match(/\/products\/([^/?#]+)/);
      if (m && handles.indexOf(m[1]) === -1) handles.push(m[1]);
    });
    handles = handles.slice(0, 4);
    if (handles.length) {
      var racine = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      Promise.all(handles.map(function (h) {
        return fetch(racine + 'products/' + h + '.js').then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
      })).then(function (produits) {
        produits.filter(Boolean).forEach(function (p) {
          var a = document.createElement('a');
          a.className = 'amb-art-carte';
          a.href = p.url;
          var media = document.createElement('span');
          media.className = 'amb-art-carte-media';
          if (p.featured_image) {
            var img = document.createElement('img');
            var src = p.featured_image.indexOf('//') === 0 ? 'https:' + p.featured_image : p.featured_image;
            img.src = src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=600';
            img.alt = p.title;
            img.loading = 'lazy';
            media.appendChild(img);
          }
          var nom = document.createElement('span');
          nom.className = 'amb-art-carte-nom';
          nom.textContent = p.title;
          var lien = document.createElement('span');
          lien.className = 'amb-art-carte-lien';
          lien.textContent = 'Découvrir';
          a.appendChild(media); a.appendChild(nom); a.appendChild(lien);
          grille.appendChild(a);
        });
        if (grille.children.length) {
          grille.style.setProperty('--amb-n', String(Math.max(2, grille.children.length)));
          zone.hidden = false;
        }
      });
    }
  }

  /* 6. Copier le lien */
  var copier = document.querySelector('[data-amb-copier]');
  if (copier) {
    copier.addEventListener('click', function () {
      var url = copier.getAttribute('data-amb-copier');
      var fin = function () { copier.textContent = 'Lien copié'; setTimeout(function () { copier.textContent = 'Copier le lien'; }, 2000); };
      if (navigator.clipboard) navigator.clipboard.writeText(url).then(fin, fin); else fin();
    });
  }
})();
